export const spisakNedelja = [
  "Седмица прва – Светла",
  "Седмица друга – Мироносица",
  "Седмица трећа – Раслабљеног",
  "Седмица четврта – Самарјанке",
  "Седмица пета – Слепога",
  "Седмица шеста – Светих Отаца Првог васељенског сабора",
  "Седмица шеста – Светих Отаца Првог васељенског сабора",
  "Седмица Педесетнице",
];
export const details = [
  { title: "Ime i prezime", name: "name" },
  { title: "Kontakt telefon", name: "tel" },
  { title: "Vaša poruka", name: "text" },
];
export const tretmanColors = [
  { tretman: "manastir", color: "#940922" },
  { tretman: "crkva", color: "#b29411" },
  { tretman: "ostalo", color: "#5F1A37" },
];
export const monthSerb = [
  "januar",
  "februar",
  "mart",
  "april",
  "maj",
  "jun",
  "jul",
  "avgust",
  "septembar",
  "oktobar",
  "novembar",
  "decembar",
];
export const prodavnicaKategorije = [
  { key: "rucno-oslikane", title: "Ručno oslikane ikone" },
  { key: "stampane-na-platnu", title: "Ikone štampane na platnu" },
  { key: "kasirane-pozlacene", title: "Kaširane i pozlaćene ikone" },
  { key: "kasirane", title: "Kaširane ikone" },
];

export const ikoneKategorije = [
  {
    route: "/ikone/bogorodica",
    title: "Bogorodica",
    titleSr: "Presveta Bogorodica",
    desc: "Ikone Presvete Bogorodice — Zaštitnice pravoslavnog naroda",
    symbol: "☩",
    color: "#4a1a6a",
  },
  {
    route: "/ikone/hristos",
    title: "Hristos",
    titleSr: "Gospod Isus Hristos",
    desc: "Ikone Gospoda Isusa Hrista — Pantokrator i ostale predstave",
    symbol: "✝",
    color: "#6a1a10",
  },
  {
    route: "/ikone/sveti",
    title: "Sveti",
    titleSr: "Sveci i Ugodnici",
    desc: "Ikone svetitelja i ugodnika Božjih pravoslavne Crkve",
    symbol: "★",
    color: "#1a4a2a",
  },
  {
    route: "/ikone/praznici",
    title: "Praznici",
    titleSr: "Crkveni praznici",
    desc: "Ikone dvanаest velikih crkvenih praznika i slava",
    symbol: "✦",
    color: "#4a3a10",
  },
  {
    route: "/ikone/arhandjeli",
    title: "Arhanđeli",
    titleSr: "Sveti Arhanđeli",
    desc: "Ikone Svetih Arhanđela Mihaila, Gavrila i Rafaila",
    symbol: "◈",
    color: "#1a3a5a",
  },
];

const PIC = "https://commons.wikimedia.org/wiki/Special:FilePath/Vladimirskaya.jpg?width=400";

export const ikonePrimeri = [
  {
    id: 1, slug: "bogorodica-umiljenija",
    tip: "rucno-oslikane",
    title: "Bogorodica Umiljenija",
    sifra: "RO-001",
    tehnika: "Jajna tempera",
    dimenzije: "30×40 cm",
    cena: "24.500 RSD",
    pic: PIC,
    opis: "Ikona Bogorodice Umiljenije, ručno oslikana jajnom temperom na daski sa levkasom u vizantijskoj tradiciji. Svaki detalj pažljivo je izveden po kanonskim uzorima. Isporučuje se sa sertifikatom autentičnosti.",
  },
  {
    id: 2, slug: "hristos-pantokrator",
    tip: "rucno-oslikane",
    title: "Hristos Pantokrator",
    sifra: "RO-002",
    tehnika: "Jajna tempera, pozlata",
    dimenzije: "25×35 cm",
    cena: "22.000 RSD",
    pic: PIC,
    opis: "Ikona Hrista Pantokratora pisana jajnom temperom sa pozlatom listićima 24k zlata. Izrađena na dasci sa levkasom po vizantijskom kanonu. Idealna za dom, crkvu ili kao poklon.",
  },
  {
    id: 3, slug: "sveti-djordje-na-konju",
    tip: "rucno-oslikane",
    title: "Sveti Đorđe na konju",
    sifra: "RO-003",
    tehnika: "Jajna tempera",
    dimenzije: "35×50 cm",
    cena: "26.000 RSD",
    pic: PIC,
    opis: "Ikona Svetog Đorđa Pobedonosca na konju, ručno oslikana jajnom temperom na drvetu. Detaljna kompozicija prema vizantijskim predlošcima. Svetac zaštitnik ratnika i putnika.",
  },
  {
    id: 4, slug: "sveti-nikola-mirlikijski",
    tip: "rucno-oslikane",
    title: "Sveti Nikola Mirlikijski",
    sifra: "RO-004",
    tehnika: "Jajna tempera, pozlata",
    dimenzije: "20×30 cm",
    cena: "21.000 RSD",
    pic: PIC,
    opis: "Ikona Svetog Nikole Mirlikijskog sa pozlatom. Sveti Nikola je jedan od najpoštovanijih svetitelja pravoslavnog sveta, zaštitnik putnika, dece i siromašnih. Pisana jajnom temperom i listićima zlata.",
  },
  {
    id: 5, slug: "vaskrsenje-hristovo",
    tip: "stampane-na-platnu",
    title: "Vaskrsenje Hristovo",
    sifra: "SP-001",
    tehnika: "Štampa na platnu",
    dimenzije: "40×55 cm",
    cena: "4.500 RSD",
    pic: PIC,
    opis: "Reprodukcija ikone Vaskrsenja Hristovog (Anastasis) odštampana na kvalitetnom platnu. Reprodukcija prema fresko slikarstvu iz manastira Hora u Carigradu, 14. vek.",
  },
  {
    id: 6, slug: "sveti-arhandjeo-mihailo",
    tip: "stampane-na-platnu",
    title: "Sveti Arhanđeo Mihailo",
    sifra: "SP-002",
    tehnika: "Štampa na platnu",
    dimenzije: "30×45 cm",
    cena: "3.800 RSD",
    pic: PIC,
    opis: "Reprodukcija ikone Svetog Arhanđela Mihaila na platnu. Arhanđel Mihailo je vođa nebeske vojske i jedan od najpoštovanijih anđela u pravoslavnoj tradiciji.",
  },
  {
    id: 7, slug: "bogorodica-trojerucica",
    tip: "kasirane-pozlacene",
    title: "Bogorodica Trojeručica",
    sifra: "KP-001",
    tehnika: "Štampa, kaširanje, pozlata",
    dimenzije: "25×35 cm",
    cena: "6.200 RSD",
    pic: PIC,
    opis: "Ikona Bogorodice Trojeručice kaširana na drvenoj podlozi sa zlatnim okvirom. Prema predanju, ikonu je oslikao Sveti Jovan Damaskin. Pozlaćeni dekorativni elementi.",
  },
  {
    id: 8, slug: "preobrazhenje-gospodnje",
    tip: "kasirane-pozlacene",
    title: "Preobraženje Gospodnje",
    sifra: "KP-002",
    tehnika: "Štampa, kaširanje, pozlata",
    dimenzije: "35×50 cm",
    cena: "7.500 RSD",
    pic: PIC,
    opis: "Ikona Preobraženja Gospodnjeg kaširana na MDF podlozi sa pozlaćenim okvirom. Prema čuvenoj kompoziciji Teofana Grka. Jedan od dvanaest velikih praznika pravoslavne crkve.",
  },
  {
    id: 9, slug: "sveta-trojica",
    tip: "kasirane",
    title: "Sveta Trojica",
    sifra: "KA-001",
    tehnika: "Štampa, kaširanje",
    dimenzije: "20×30 cm",
    cena: "2.800 RSD",
    pic: PIC,
    opis: "Ikona Svete Trojice prema čuvenoj kompoziciji Andreja Rubljova, kaširana na drvenoj podlozi. Jedna od najlepših ikona hrišćanske tradicije koja prikazuje tri anđela.",
  },
  {
    id: 10, slug: "bogorodica-odigitria",
    tip: "kasirane",
    title: "Bogorodica Odigitria",
    sifra: "KA-002",
    tehnika: "Štampa, kaširanje",
    dimenzije: "25×35 cm",
    cena: "3.200 RSD",
    pic: PIC,
    opis: "Ikona Bogorodice Odigitrie (Putevoditeljke) kaširana na drvenoj podlozi. Jedan od najstarijih tipova prikaza Bogorodice sa Hristom. Zaštitnica putnika i hodočasnika.",
  },
];

export const options = [
  //0
  {
    route: "/",
    title: "Ikone.rs",
    social: {
      title: "Ikone.rs",
      lead: "Ikone.rs - Ikone, crkveni kalendar, manastiri...",
      pics: "/img/test3.jpg",
    },
  },
  //1
  // { route: "/manastiri/", title: "Manastiri" },
  //2
  {
    route: "/ikone",
    title: "Ikone",
  },
  //3
  {
    route: "/crkveni-kalendar/",
    title: "Crkveni kalendar",
    social: {
      title: "Crkveni kalendar",
      lead: "Crkveni pravoslavni kalendar | Svi praznici, slave i posti u godini na jednom mestu. Srpske crkve i manastiri, posni recepti, molitve | Crkveni kalendar",
      pics: "/img/test3.jpg",
    },
    social2: {
      title: "Crkveni kalendar",
      lead: " | Svi praznici, slave i posti u godini na jednom mestu. Srpske crkve i manastiri, posni recepti, molitve | Crkveni kalendar ",
      pics: "/img/test3.jpg",
    },
    item_list: [
      {
        title: "Januar 2026",
        route: "/crkveni-kalendar/2026/januar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Februar 2026",
        route: "/crkveni-kalendar/2026/februar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Mart 2026",
        route: "/crkveni-kalendar/2026/mart/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "April 2026",
        route: "/crkveni-kalendar/2026/april/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Maj 2026",
        route: "/crkveni-kalendar/2026/maj/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Jun 2026",
        route: "/crkveni-kalendar/2026/jun/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Jul 2026",
        route: "/crkveni-kalendar/2026/jul/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Avgust 2026",
        route: "/crkveni-kalendar/2026/avgust/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Septembar 2026",
        route: "/crkveni-kalendar/2026/septembar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Oktobar 2026",
        route: "/crkveni-kalendar/2026/oktobar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Novembar 2026",
        route: "/crkveni-kalendar/2026/novembar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
      {
        title: "Decembar 2026",
        route: "/crkveni-kalendar/2026/decembar/",
        social: {
          title: "Običaji i tradicija",
          lead: "Najnovije vesti - Običaji i tradicija",
          pics: "https://res.cloudinary.com/dvi29tcsc/image/upload/v1678366923/ads/agroweb_green_l2ql6w.jpg",
        },
      },
    ],
  },
  //4
  {
    route: "/ostalo/meseceve-mene/",
    title: "Mesečeve mene",
    social: {
      title: "Mesečeve mene",
      lead: "Mesečeve mene i lunarne faze u 2026. godini. MESEČEV KALENDAR. Precizan kalendar faza meseca za kompletnu godinu. Prikaz mesečevih mena za svaki mesec...",
      pics: ["/img/article_img/moon.jpg", "Pexels"],
    },
  },
  //5
  // {
  //   route: "/zadusnice",
  //   title: "Zadušnice",
  // },
  // { route: "/molitve", title: "Molitve" },
  { route: "/slave/", title: "Slave" },
  // { route: "/ostalo", title: "Ostalo" },
];

export const footer = [
  "O nama",
  "Marketing",
  "Pravila korišćenja",
  "Politika privatnosti",
];
